/**
 * React Query key factory for admin-related queries.
 * Follows the auth/Forge pattern: centralized, composable, type-safe.
 */

import type { ListUsersParams } from './types'

export const adminKeys = {
  all: ['admin'] as const,
  users: () => [...adminKeys.all, 'users'] as const,
  userList: (params: ListUsersParams) =>
    [...adminKeys.users(), params] as const,
  userDetail: (id: string) =>
    [...adminKeys.users(), 'detail', id] as const,
  userNotes: (id: string) =>
    [...adminKeys.users(), 'notes', id] as const,
  analytics: () => [...adminKeys.all, 'analytics'] as const,
  // Phase 16 Plan 08: products / productDetail keys deleted. The console
  // page uses cmsAdminKeys.list('products', ...) / .detail('products', id)
  // (Plan 16-03 — collection-parameterized factory).
}
